import React, { memo, useMemo, useState, type FC } from "react";
import clsx from "clsx";
import WalletAddressAvatar from "./WalletAddressAvatar";
import { FallbackUserAvatar } from "~/src/assets/img";

interface NormalAvatarProps {
  url?: string;
  width?: number;
  height?: number;
  isBordered?: boolean;
  walletAddress: string;
}

const NormalAvatar: FC<NormalAvatarProps> = ({
  width,
  height,
  url,
  walletAddress,
  isBordered = false,
}) => {
  const [imageError, setImageError] = useState(false);
  const exactHeight = useMemo(() => {
    return height ?? width;
  }, [height, width]);

  if (url) {
    return (
      <div className="flex" style={{ width, height: exactHeight }}>
        <img
          src={imageError ? FallbackUserAvatar : url}
          onError={() => {
            setImageError(true);
          }}
          loading="lazy"
          decoding="async"
          alt="avatar"
          className={clsx(
            "size-full object-cover border bg-gray-200 rounded-full",
            isBordered ? "border border-primary" : ""
          )}
          style={{ width, height: exactHeight }}
        />
      </div>
    );
  }
  return (
    <WalletAddressAvatar
      walletAddress={walletAddress}
      isBordered={isBordered}
      height={exactHeight}
      width={width}
    />
  );
};

export default memo(NormalAvatar);
